(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-article"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('routine-article')) {
    class RoutineArticle extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-article-body]');
        this.markCallouts();
        this.buildContents();
        this.trackProgress();
        this.querySelectorAll('[data-share-copy]').forEach((btn) => btn.addEventListener('click', () => this.copy(btn)));
        this.querySelectorAll('[data-share-native]').forEach((btn) => {
          if (navigator.share) {
            btn.hidden = false;
            btn.addEventListener('click', () => navigator.share({ title: document.title, url: btn.dataset.url }).catch(() => {}));
          }
        });
      }

      // Paragraphs that open with a bold "Quick answer:" (or similar) become a highlighted summary box.
      markCallouts() {
        const lead = /^(quick answer|in short|key takeaways?|the short answer|tl;?dr)\b/i;
        this.body.querySelectorAll('p').forEach((p) => {
          const first = p.firstElementChild;
          if (first && /^(STRONG|B)$/.test(first.tagName) && p.textContent.trim().startsWith(first.textContent.trim()) && lead.test(first.textContent.trim())) {
            p.classList.add('rj-callout');
          }
        });
      }

      buildContents() {
        const wrap = this.querySelector('[data-toc-wrap]');
        const list = this.querySelector('[data-toc-list]');
        const headings = [...this.body.querySelectorAll('h2')].filter((h) => h.textContent.trim());
        if (headings.length < 3) return;

        const used = new Set();
        this.links = headings.map((h) => {
          if (!h.id) {
            let id = h.textContent.trim().toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').slice(0, 60) || 'section';
            while (used.has(id) || document.getElementById(id)) id += '-1';
            h.id = id;
          }
          used.add(h.id);
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `#${h.id}`;
          a.textContent = h.textContent.trim();
          li.append(a);
          list.append(li);
          return { h, a };
        });
        wrap.hidden = false;

        // Collapsed by default on phones and tablets, where it sits above the article.
        const details = this.querySelector('[data-toc-details]');
        const wide = window.matchMedia('(min-width: 1200px)');
        const sync = () => { details.open = wide.matches; };
        sync();
        wide.addEventListener('change', sync);
        list.addEventListener('click', () => { if (!wide.matches) details.open = false; });
      }

      trackProgress() {
        const bar = document.querySelector('[data-progress]');
        if (!bar) return;
        let ticking = false;
        const update = () => {
          const r = this.body.getBoundingClientRect();
          const total = r.height - window.innerHeight * 0.6;
          const done = Math.min(Math.max(-r.top + window.innerHeight * 0.2, 0), Math.max(total, 1));
          bar.style.transform = `scaleX(${(done / Math.max(total, 1)).toFixed(4)})`;
          this.markActive();
          ticking = false;
        };
        const onScroll = () => {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
          }
        };
        // The theme may scroll an inner wrapper instead of the window; listen to both.
        window.addEventListener('scroll', onScroll, { passive: true });
        document.addEventListener('scroll', onScroll, { passive: true, capture: true });
        update();
      }

      // Highlight the contents entry for the section currently being read.
      markActive() {
        if (!this.links) return;
        const line = window.innerHeight * 0.3;
        let current = null;
        this.links.forEach((link) => {
          if (link.h.getBoundingClientRect().top <= line) current = link;
        });
        this.links.forEach((link) => link.a.setAttribute('aria-current', String(link === current)));
      }

      async copy(btn) {
        const label = btn.querySelector('[data-label]');
        try {
          await navigator.clipboard.writeText(btn.dataset.url);
          const prev = label.textContent;
          label.textContent = 'Link copied';
          setTimeout(() => { label.textContent = prev; }, 2000);
        } catch (e) {
          window.prompt('Copy this link', btn.dataset.url);
        }
      }
    }
    customElements.define('routine-article', RoutineArticle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-journal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('routine-journal')) {
    class RoutineJournal extends HTMLElement {
      connectedCallback() {
        this.perPage = parseInt(this.dataset.perPage, 10) || 13;
        this.limit = this.perPage;
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.input = this.querySelector('[data-search-input]');
        this.clearBtn = this.querySelector('[data-search-clear]');
        this.status = this.querySelector('[data-status]');
        this.empty = this.querySelector('[data-empty]');
        this.emptyLink = this.querySelector('[data-empty-link]');
        this.moreWrap = this.querySelector('[data-more-wrap]');
        this.emptyBase = this.emptyLink.getAttribute('href');

        this.query = (new URLSearchParams(location.search).get('q') || '').trim();
        this.input.value = this.query;

        let t;
        this.input.addEventListener('input', () => {
          clearTimeout(t);
          t = setTimeout(() => this.search(this.input.value), 120);
        });
        this.querySelector('[data-search-form]').addEventListener('submit', (e) => {
          e.preventDefault();
          this.input.blur();
        });
        this.clearBtn.addEventListener('click', () => {
          this.search('');
          this.input.focus();
        });
        this.querySelector('[data-reset]').addEventListener('click', () => this.search(''));
        this.querySelector('[data-more]').addEventListener('click', () => {
          const firstNew = this.visible[this.limit];
          this.limit += this.perPage;
          this.render();
          firstNew?.querySelector('a')?.focus({ preventScroll: true });
        });

        this.revealActiveChip();
        this.render();
      }

      search(value) {
        this.query = value.trim();
        this.input.value = value;
        this.limit = this.perPage;
        this.render();
        const url = new URL(location.href);
        this.query ? url.searchParams.set('q', this.query) : url.searchParams.delete('q');
        history.replaceState(null, '', url);
      }

      render() {
        const terms = this.query.toLowerCase().split(/\s+/).filter(Boolean);
        this.visible = this.cards.filter((card) => terms.every((term) => card.dataset.search.includes(term)));

        this.cards.forEach((card) => {
          card.hidden = true;
          card.classList.remove('rj-card--lead');
        });
        this.visible.slice(0, this.limit).forEach((card, i) => {
          card.hidden = false;
          // Feature a lead story only when browsing, not when showing search results.
          if (i === 0 && !terms.length) card.classList.add('rj-card--lead');
        });

        this.clearBtn.hidden = !this.query;
        this.moreWrap.hidden = this.visible.length <= this.limit;

        const n = this.visible.length;
        this.empty.hidden = n > 0;
        if (n === 0) {
          this.querySelector('[data-empty-term]').textContent = this.query;
          const sep = this.emptyBase.includes('?') ? '&' : '?';
          this.emptyLink.href = this.emptyBase + sep + 'q=' + encodeURIComponent(this.query);
        }
        this.status.textContent = terms.length ? `${n} ${n === 1 ? 'article' : 'articles'} for “${this.query}”` : '';
      }

      // On phones the chips scroll sideways; bring the current category into view.
      revealActiveChip() {
        const track = this.querySelector('[data-chip-track]');
        const active = track?.querySelector('[aria-current="page"]');
        if (!active || track.scrollWidth <= track.clientWidth) return;
        track.scrollLeft = active.offsetLeft - (track.clientWidth - active.offsetWidth) / 2;
      }
    }
    customElements.define('routine-journal', RoutineJournal);
  }

  } catch(e) { console.error(e); }
})();
})();
